import { overrides } from './overrides'
import { tokens } from './tokens'

export { typeScale } from './tokens'
export const theme = { ...tokens, overrides }
export const border = `1px solid ${tokens.palette.grey[100]}`
